import React, { useRef } from 'react';
import ReactDOM from 'react-dom';

import { ReactComponent as CloseCircle } from '../../assets/icons/close-circle.svg';

interface ModalBoxProperties {
  title: string | null;
  content: JSX.Element | null;
  closeModal: () => void;
  open: boolean;
  header: boolean;
  rightCorner?: boolean;
  modalBoxAnimation?: 'modalAnimateToTop' | 'modalAnimateToLeft';
  notification?: boolean;
  fullHeightWidth?: boolean;
}

/**
 * Common modal box
 */
function ModalBox({
  title,
  content,
  closeModal,
  open,
  header,
  rightCorner,
  modalBoxAnimation,
  notification,
  fullHeightWidth,
}: ModalBoxProperties) {
  const reference = useRef<HTMLDivElement>(null);
  return open
    ? ReactDOM.createPortal(
        <div
          className={`modal-box-wrap ${open && 'open'} ${rightCorner && 'right-top'}`}
          ref={reference}>
          <div
            style={
              {
                '--modal-animation': modalBoxAnimation,
                ...(fullHeightWidth && {
                  height: '100%',
                  width: '100%',
                }),
              } as React.CSSProperties
            }
            className="modal-box-container">
            {header && (
              <div className="modal-box-header">
                <div className="modal-box-title">
                  <span>{title}</span>
                </div>
                {!notification && (
                  <div className="modal-box-icon" onClick={closeModal} role="presentation">
                    <CloseCircle />
                  </div>
                )}
              </div>
            )}
            <div className="modal-box-body">
              {!header && !notification && (
                <div className="modal-box-icon" onClick={closeModal} role="presentation">
                  <CloseCircle />
                </div>
              )}
              {content}
            </div>
          </div>
        </div>,
        document.body,
      )
    : null;
}

ModalBox.defaultProps = {
  rightCorner: false,
  modalBoxAnimation: 'modalAnimateToTop',
  notification: false,
  fullHeightWidth: false,
};

export default ModalBox;
